import * as io from 'io-ts'
import { mapPartial } from '../../../../io-ts/mapPartial'

export const makeGetBudgetFlowNodeDecoder = () =>
  mapPartial({
    authToken: io.string,
  })

export type TGetBudgetFlowNode = io.TypeOf<ReturnType<typeof makeGetBudgetFlowNodeDecoder>>
